import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomeScreen from '../screens/home'; // home page

/* rotas de usuários */
import LoginScreen from '../screens/auth/login'; // login do fiscal
import UserLoggedScreen from '../screens/auth/usuarios'; // tela de gerenciamento dos fiscais
import CadUserScreen from '../screens/auth/usuarios/cadastrar'; // cadastro de fiscal
import ListUserScreen from '../screens/auth/usuarios/listar'; // listagem de fiscais
import EditarUserScreen from '../screens/auth/usuarios/editar'; // edição de fiscal
import SenhaScreen from '../screens/auth/usuarios/senha'; // edição de fiscal
/* fim todas de usuários */

/*rotas Perguntas*/
import PerguntasScreen from '../screens/perguntas'; //tela principal Perguntas
/*fim rotas Perguntas*/

/*rotas LGPD*/
import LGPDScreen from '../screens/lgpd'; //tela principal LGPD
import LGPDFormScreen from '../screens/lgpd/formulario'; //tela formulário pedindo dados
/*fim rotas LGPD*/

/*rotas Perguntas*/
import MapaScreen from '../screens/mapa'; //tela principal Perguntas
/*fim rotas Perguntas*/


/*rotas Contas*/
import ContasScreen from '../screens/contas'; //tela principal Contas
import PrestContasScreen from '../screens/contas/prestacaocontas'; //tela de prestação de Contas
import CamaraPrestScreen from '../screens/contas/camara'; //tela de apreciação da câmra
import AudPubScreen from '../screens/contas/audiencias'; //tela de audiências públicas
import RenunciaDocScreen from '../screens/contas/renuncias'; //tela de renuncias de receitas
import MetasFiscaisScreen from '../screens/contas/audiencias/metasfiscais'; //tela de metas fiscais
import ContasLoggedScreen from '../screens/auth/prestcontas'; // tela de principal contas
import CadContasScreen from '../screens/auth/prestcontas/cadastrar'; // tela de cadastro de contas
import ListContasScreen from '../screens/auth/prestcontas/listar'; // tela de listagem de contas
import EditarContasScreen from '../screens/auth/prestcontas/editar'; // tela de edição de contas
/*fim rotas Contas*/


/*rotas de leis*/
import OrcamentoLeiScreen from '../screens/leis'; //home das leis orçamentárias
import LeisScreen from '../screens/leis/listar'; //tela listar todas leis pública
import PrivateLeiRoute from '../components/auth/private_route_leis'; //rota privada das leis
import HomeLoggedLeiScreen from '../screens/auth/leis'; //tela logada legislador
import EditarLeiScreen from '../screens/auth/leis/editar'; //editar lei
import CadLeiScreen from '../screens/auth/leis/cadastrar'; //cadastrar lei
import ListLeiScreen from '../screens/auth/leis/listar'; //listar leis
import IndLeiScreen from '../screens/auth/leis/indiceleis'; //índice leis logado
import IndDecScreen from '../screens/auth/leis/indicedecretos'; //índice decretos logado
import DataLeiScreen from '../screens/auth/leis/data'; // alterar data da lei logado
import JornalLeiScreen from '../screens/auth/leis/jornal'; // alterar jornal da lei logado
import EmentaLeiScreen from '../screens/auth/leis/ementa'; // alterar ementa da lei logado
import ArquivoLeiScreen from '../screens/auth/leis/arquivo'; //alterar arquivo da lei logado
import DecretosScreen from '../screens/leis/decretos'; // lista de decretos pública
import MunicipaisScreen from '../screens/leis/municipais'; // lista de leis municipais pública
import TranspScreen from '../screens/leis/transparencia'; // lista de leis de transparencia pública
import LdoScreen from '../screens/leis/ldo'; // lista de leis de diretrizes orçamentárias públicas
import LoaScreen from '../screens/leis/loa'; // lista de leis orçamentárias anuais públicas
import PpaScreen from '../screens/leis/ppa'; // lista de planos plurianuais públicas
import CovidLeisScreen from '../screens/leis/covid'; // lista de planos plurianuais públicas
/* fins rotas de leis */

/*rotas de licitações*/
import LicsScreen from '../screens/licitacao'; //tela inicial licitação
import LicsTodasScreen from '../screens/licitacao/todas'; //tela listar todas licitações pública
import DispensaCovidScreen from '../screens/licitacao/dispensa-covid'; //tela listar todas licitações pública
import HomeLoggedLicScreen from '../screens/auth/licitacao'; //tela logada licitador
import LicScreen from '../screens/auth/licitacao/licitacao'; //editar licitacao
import EditarLicScreen from '../screens/auth/licitacao/editar'; //editar licitacao
import CadLicScreen from '../screens/auth/licitacao/cadastrar'; //cadastrar licitacao
import CadAvisoScreen from '../screens/auth/licitacao/aviso'; //cadastrar aviso de licitacao
import ListLicAtivaScreen from '../screens/auth/licitacao/listar/andamento'; //listar licitacao em andamento logado
import ListLicEncScreen from '../screens/auth/licitacao/listar/encerradas'; //listar licitacao encerradas logado
import ListAvisosScreen from '../screens/auth/licitacao/listar/avisos'; //listar licitacao encerradas logado
import ListTodasScreen from '../screens/auth/licitacao/listar/todas'; //listar todas licitações logado
import SituacaoLicScreen from '../screens/auth/licitacao/situacao'; // alterar situação licitacao logado
import ValorLicScreen from '../screens/auth/licitacao/valor'; // alterar valor licitação logado
import ObjetiLicScreen from '../screens/auth/licitacao/objeto'; // alterar objeto da licitacao logado
import AnexosLicScreen from '../screens/auth/licitacao/anexos'; //anexar arquivos da licitacao logado
import AvisosLicScreen from '../screens/licitacao/avisos'; // lista de avisos de licitacao pública
import AndamentoLicScreen from '../screens/licitacao/andamento'; // lista de licitações em andamento pública
import EncerradasLicScreen from '../screens/licitacao/encerradas'; // lista de licitações encerradas pública
import CovidLicScreen from '../screens/licitacao/covid'; // lista de licitações feitas durante a pandemia de COVID-19
import Expo25LicitacaoScreen from '../screens/licitacao/expomacuco/2025'; // lista de licitacao feitos para Expo Macuco 2025
import Expo24LicitacaoScreen from '../screens/licitacao/expomacuco/2024'; // lista de licitacao feitos para Expo Macuco 2024
import Expo23LicitacaoScreen from '../screens/licitacao/expomacuco/2023'; // lista de licitacao feitos para Expo Macuco 2023
import ExpoAntLicitacaoScreen from '../screens/licitacao/expomacuco/anteriores'; // lista de licitacao feitos para Expo Macuco Anos anteriores
/* fins rotas de licitações */

/*rotas de contratos*/
import ContratosScreen from '../screens/contratos'; //tela home contratos pública
import ListContratosScreen from '../screens/contratos/listar'; //tela listagem de contratos
import FiscaisContratosScreen from '../screens/contratos/fiscais'; //tela de fiscais de contratos municipais
import ContratadosContratosScreen from '../screens/contratos/contratados'; //tela de contratados municipais
import LicitantesContratosScreen from '../screens/contratos/licitantes'; //tela de licitantes municipais
import CovidContratosScreen from '../screens/contratos/covid'; // lista de contratos feitos durante a pandemia de COVID-19
import Expo25ContratosScreen from '../screens/contratos/expomacuco/2025'; // lista de contratos feitos para Expo Macuco 2025
import Expo24ContratosScreen from '../screens/contratos/expomacuco/2024'; // lista de contratos feitos para Expo Macuco 2024
import Expo23ContratosScreen from '../screens/contratos/expomacuco/2023'; // lista de contratos feitos para Expo Macuco 2023
import ExpoAntContratosScreen from '../screens/contratos/expomacuco/anteriores'; // lista de contratos feitos para Expo Macuco Anos anteriores
import ChamamentosContratosScreen from '../screens/contratos/chamamentos'; // lista de contratos de chamamentos da saúde
import HomeLoggedContratoScreen from '../screens/auth/contratos'; //tela logada contratos
import ContratoScreen from '../screens/auth/contratos/contrato'; //ver contrato
import EditarContratoScreen from '../screens/auth/contratos/editar'; //editar contrato
import CadContratoScreen from '../screens/auth/contratos/cadastrar'; //cadastrar contrato
import ListContratoScreen from '../screens/auth/contratos/listar'; //listar contratos logado
import FiscContratoScreen from '../screens/auth/contratos/fiscais'; //tela logada de fiscais de contratos
import EditarFiscContratoScreen from '../screens/auth/contratos/fiscais/editar'; //editar fiscal de contrato
import CadFiscContratoScreen from '../screens/auth/contratos/fiscais/cadastrar'; //cadastrar fiscal de contrato
import ListFiscContratoScreen from '../screens/auth/contratos/fiscais/listar'; //listar fiscal de contratos logado
import SituacaoContratoScreen from '../screens/auth/contratos/situacao'; // alterar situação contrato logado
import AditivoContratoScreen from '../screens/auth/contratos/aditivo'; //anexar aditivo contrato logado
import ChamamentoSaudeScreen from '../screens/auth/contratos/chamamento'; //cadastro de contratos de chamamentos públicos da saúde

/* fins rotas de contratos */


// rotas do adm
import AdmLoggedScreen from '../screens/auth/home'; //tela principal do adm transparencia
import PrivateRoute from '../components/auth/private_route'; //rota privada do adm
// fim rotas do adm


// rotas do controle interno
import ControleLoggedScreen from '../screens/auth/controle'; //tela principal do controle interno na transparencia
// fim rotas controle interno


/*rotas de diario*/
import DiarioScreen from '../screens/diario'; //tela listar todos diários pública
import DiarioExpo2025Screen from '../screens/diario/expomacuco/2025'; //tela listar diário expo macuco 2025
import DiarioExpo2024Screen from '../screens/diario/expomacuco/2024'; //tela listar diário expo macuco 2024
import DiarioExpo2023Screen from '../screens/diario/expomacuco/2023'; //tela listar diário expo macuco 2023
import DiarioExpoAntScreen from '../screens/diario/expomacuco/anteriores'; //tela listar diário expo macuco anteriores
import DiarioLoggedScreen from '../screens/auth/diario'; //tela logada diário
import EditarDiarioScreen from '../screens/auth/diario/editar'; //editar Diario
import CadDiarioScreen from '../screens/auth/diario/cadastrar'; //cadastrar Diario
import ListDiarioScreen from '../screens/auth/diario/listar'; //listar Diarios logado
import ArquivoDiarioScreen from '../screens/auth/diario/arquivo'; //alterar arquivo do diário logado
/* fins rotas de diario */

/*rotas de veiculos*/
import VeiculosScreen from '../screens/veiculos'; //tela listar todos diários pública
import VeiculoLoggedScreen from '../screens/auth/veiculos'; //tela logada diário
import EditarVeiculosScreen from '../screens/auth/veiculos/editar'; //editar Veiculos
import CadVeiculosScreen from '../screens/auth/veiculos/cadastrar'; //cadastrar Veiculos
import ListVeiculosScreen from '../screens/auth/veiculos/listar'; //listar Veiculoss logado
/* fins rotas de veiculos */

/*rotas de atos do governo*/
import AtosScreen from '../screens/atos'; //tela listar todos atos públicos
import AtosLoggedScreen from '../screens/auth/atos'; //tela logada atos
import EditarAtosScreen from '../screens/auth/atos/editar'; //editar atos
import CadAtosScreen from '../screens/auth/atos/cadastrar'; //cadastrar atos
import ListAtosScreen from '../screens/auth/atos/listar'; //listar atos logado
import ArquivoAtosScreen from '../screens/auth/atos/arquivo'; //alterar arquivo do diário logado
/* fins rotas de atos do governo */

/*rotas de divida ativa*/
import DividaScreen from '../screens/divida'; //tela listar todos dívidas ativas
import DividaLoggedScreen from '../screens/auth/divida'; //tela logada dividas
import EditarDividaScreen from '../screens/auth/divida/editar'; //editar divida
import CadDividaScreen from '../screens/auth/divida/cadastrar'; //cadastrar divida
import ListDividaScreen from '../screens/auth/divida/listar'; //listar divida logado
/* fins rotas de divida ativa */

/*rotas de renuncias de receitas e projetos culturais */
import RenunciasScreen from '../screens/renunciareceita/renuncia'; //tela Renúncias
import ProjetoculturalScreen from '../screens/projetocultural'; //tela listar todos projetos culturais
import ProjetoCulturalLoggedScreen from '../screens/auth/projetocultural'; //tela logada projeto cultural
import EditarProjetoCulturalScreen from '../screens/auth/projetocultural/editar'; //editar projeto cultural
import CadProjetoCulturalScreen from '../screens/auth/projetocultural/cadastrar'; //cadastrar projeto cultural
import ListProjetoCulturalScreen from '../screens/auth/projetocultural/listar'; //listar projeto cultural logado
import RenunciaReceitaScreen from '../screens/renunciareceita'; //tela listar todas renuncias de receitas
import RenunciasLoggedScreen from '../screens/auth/renuncias'; //tela logada renuncia de receita
import RenunciaReceitaLoggedScreen from '../screens/auth/renunciareceita'; //tela logada renuncia de receita
import EditarRenunciaReceitaScreen from '../screens/auth/renunciareceita/editar'; //editar renuncia de receita
import CadRenunciaReceitaScreen from '../screens/auth/renunciareceita/cadastrar'; //cadastrar renuncia de receita
import ListRenunciaReceitaScreen from '../screens/auth/renunciareceita/listar'; //listar renuncia de receita logado
/* fins rotas de renuncias de receitas e projetos culturais */

/*rotas de institucional*/
import SecretariaScreen from '../screens/secretaria'; //tela listar todos secretarias
import InstitucionalLoggedScreen from '../screens/auth/institucional'; //tela logada institucional
import SecretariaLoggedScreen from '../screens/auth/institucional/secretaria'; //tela logada secretarias
import EditarSecretariaScreen from '../screens/auth/institucional/secretaria/editar'; //editar secretaria
import CadSecretariaScreen from '../screens/auth/institucional/secretaria/cadastrar'; //cadastrar secretaria
import ListSecretariaScreen from '../screens/auth/institucional/secretaria/listar'; //listar secretaria logado
import OrgaosScreen from '../screens/orgaos'; //tela principal Orgaos
import CartaScreen from '../screens/carta'; //tela carta de serviços
import ListLocsSaudeScreen from '../screens/locais/saude'; // listagem pública de locais da saúde
import ListLocsEducScreen from '../screens/locais/educacao'; // listagem pública de locais da educação
import ListLocsSocialScreen from '../screens/locais/social'; // listagem pública de locais da assistencia social
import ListLocsEsporteScreen from '../screens/locais/esporte'; // listagem pública de locais do esporte
import ListLocsTodasScreen from '../screens/locais'; // listagem pública de locais gerais
import LocLoggedScreen from '../screens/auth/institucional/locais'; //tela de locais da saude
import LocCadLoggedListScreen from '../screens/auth/institucional/locais/cadastrar'; //tela de cadastro de locais 
import LocEditLoggedListScreen from '../screens/auth/institucional/locais/editar'; //tela de edição de locais
import LocListLoggedListScreen from '../screens/auth/institucional/locais/listar'; //tela de listagem locais
import CartaServicoLoggedScreen from '../screens/auth/institucional/cartaservico'; //tela logada carta de serviços
import EditarCartaServicoScreen from '../screens/auth/institucional/cartaservico/editar'; //editar carta de serviços
import CadCartaServicoScreen from '../screens/auth/institucional/cartaservico/cadastrar'; //cadastrar carta de serviços
import ListCartaServicoScreen from '../screens/auth/institucional/cartaservico/listar'; //listar carta de serviços logado
import VisualizarCartaServicoScreen from '../screens/auth/institucional/cartaservico/carta'; //visualizar carta logado
/* fins rotas de institucional */

/*rotas de recursos partidos*/
import PartidoScreen from '../screens/partido'; //tela listar todos Partido públicos
import PartidoLoggedScreen from '../screens/auth/partido'; //tela logada Partido
import EditarPartidoScreen from '../screens/auth/partido/editar'; //editar Partido
import CadPartidoScreen from '../screens/auth/partido/cadastrar'; //cadastrar Partido
import ListPartidoScreen from '../screens/auth/partido/listar'; //listar Partido logado
import ArquivoPartidoScreen from '../screens/auth/partido/arquivo'; //alterar arquivo do partido
/* fins rotas de recursos partidos */

/*rotas do RH*/
import FolhaScreen from '../screens/folha'; //tela principal Folha
import ConcursoScreen from '../screens/folha/concurso'; //tela listar todos concursos públicos
import Concurso2001Screen from '../screens/folha/concurso/2001'; //tela listar concurso 2001
import Concurso2010Screen from '../screens/folha/concurso/2010'; //tela listar concurso 2010
import Concurso2012Screen from '../screens/folha/concurso/2012'; //tela listar concurso 2012
import EstagiariosScreen from '../screens/folha/estagiarios'; //tela listar todos estagiários 
import TerceirizadosScreen from '../screens/folha/terceirizados'; //tela listar todos terceirizados
import RHLoggedScreen from '../screens/auth/rh'; //tela logada rh
import ConcursoLoggedScreen from '../screens/auth/rh/concursos'; //tela logada concursos
import EditarConcursoScreen from '../screens/auth/rh/concursos/editar'; //editar concurso
import CadConcursoScreen from '../screens/auth/rh/concursos/cadastrar'; //cadastrar concurso
import ListConcursosScreen from '../screens/auth/rh/concursos/listar'; //listar concursos logado
import TerceirizadoLoggedScreen from '../screens/auth/rh/terceirizados'; //tela logada terceirizados
import EditarTerceirizadoScreen from '../screens/auth/rh/terceirizados/editar'; //editar terceirizado
import CadTerceirizadoScreen from '../screens/auth/rh/terceirizados/cadastrar'; //cadastrar terceirizado
import ListTerceirizadosScreen from '../screens/auth/rh/terceirizados/listar'; //listar terceirizados logado
import EstagiarioLoggedScreen from '../screens/auth/rh/estagiarios'; //tela logada estagiario
import EditarEstagiarioScreen from '../screens/auth/rh/estagiarios/editar'; //editar estagiarios
import CadEstagiarioScreen from '../screens/auth/rh/estagiarios/cadastrar'; //cadastrar estagiario
import ListEstagiariosScreen from '../screens/auth/rh/estagiarios/listar'; //listar estagiarios logado
/* fins rotas do RH*/

/*rotas de obras*/
import ObrasScreen from '../screens/obras'; //tela de obras
import TodasObrasScreen from '../screens/obras/todas'; //tela listar todas obras públicas
import ObrasParalizadasScreen from '../screens/obras/paralizadas'; //tela listar obras paralizadas
import ObrasLoggedScreen from '../screens/auth/obras'; //tela logada Obras
import EditarObraScreen from '../screens/auth/obras/editar'; //editar Obra
import CadObraScreen from '../screens/auth/obras/cadastrar'; //cadastrar Obra
import ListObraScreen from '../screens/auth/obras/listar'; //listar Obras logado
/* fins rotas de obras */

/*rotas Diarias*/
import DiariasScreen from '../screens/diarias'; //tela principal Diarias
import TabelaDiariasScreen from '../screens/diarias/tabela'; //tela de obras
import DiariasLoggedScreen from '../screens/auth/diarias'; //tela logada Diarias
import EditarDiariascreen from '../screens/auth/diarias/editar'; //editar Obra
import CadDiariascreen from '../screens/auth/diarias/cadastrar'; //cadastrar Obra
import ListDiariascreen from '../screens/auth/diarias/listar'; //listar Diarias logado
/*fim rotas Diarias*/

/*rotas Social*/
import SocialScreen from '../screens/social'; //tela principal Social
import AuxilioMacucoScreen from '../screens/social/auxiliomacuco'; //tela do Auxílio Macuco
/*fim rotas Social*/

/*rotas de LRF*/
import LrfScreen from '../screens/lrf'; //tela inicial LRF
import LrfListScreen from '../screens/lrf/listar'; //tela lista pública LRF
import RreoScreen from '../screens/lrf/rreo'; //tela de RREO pública
import RgfScreen from '../screens/lrf/rgf'; //tela de RGF pública
import DcrgfScreen from '../screens/lrf/dcrgf'; //tela de DCRGF pública
import LrfLoggedScreen from '../screens/auth/lrf'; //tela logada LRF
import EditarLrfScreen from '../screens/auth/lrf/editar'; //editar LRF
import CadLrfScreen from '../screens/auth/lrf/cadastrar'; //cadastrar LRF
import ListLrfScreen from '../screens/auth/lrf/listar'; //listar LRF logado
/* fins rotas de LRF */

/*rotas de ouvidoria*/
import OuvidoriaLoggedScreen from '../screens/auth/ouvidoria'; //tela logada ouvidoria
import AdmLoggedListScreen from '../screens/auth/ouvidoria/adm'; //listagem administra
import EsicLoggedListScreen from '../screens/auth/ouvidoria/esic'; //listagem e-sic
import EditarOuvidoriaScreen from '../screens/auth/ouvidoria/editar'; //editar ouvidoria
import HomeOuvidoriaScreen from '../screens/ouvidoria'; //Página Inicial Ouvidoria
import EstOuvidoriaScreen from '../screens/ouvidoria/estatisticas'; //estatísticas ouvidoria
import CadOuvidoriaScreen from '../screens/ouvidoria/cadastrar'; //cadastrar ouvidoria
import ListOuvidoriaScreen from '../screens/ouvidoria/listar'; //listar ouvidorias públicas
import RespOuvidoriaScreen from '../screens/ouvidoria/responder'; //responder ouvidorias públicas
import ComoPedirOuvidoriaScreen from '../screens/ouvidoria/comopedir'; //como pedir ouvidorias públicas
import ComoAcompOuvidoriaScreen from '../screens/ouvidoria/comoacompanhar'; //como acompanhar ouvidorias públicas
import RecursoOuvidoriaScreen from '../screens/ouvidoria/recurso'; //como pedir recurso ouvidorias públicas
import LeisOuvidoriaScreen from '../screens/ouvidoria/legislacao'; //Legislação de acesso à informação
import InfoOuvidoriaScreen from '../screens/ouvidoria/informacoes'; //informações de acesso à informação
import ManuaisOuvidoriaScreen from '../screens/ouvidoria/manuais'; //informações de acesso à informação
import SigiloOuvidoriaScreen from '../screens/ouvidoria/sigilo'; //informações em sigilo
import DesclassificadasOuvidoriaScreen from '../screens/ouvidoria/desclassificadas'; //informações desclassificadas
import PublicasOuvidoriaScreen from '../screens/ouvidoria/publicas'; //listagem de requisições públicas
import PesquisaScreen from '../screens/pesquisa'; //tela principal Pesquisa
import ResultadoPesquisaScreen from '../screens/pesquisa/resultados'; //tela de obras
import PesquisaLoggedScreen from '../screens/auth/ouvidoria/pesquisa'; //tela logada Pesquisa
/* fins rotas de ouvidoria */

/*rotas de saude*/
import SaudeLoggedListScreen from '../screens/auth/saude'; //tela lista logada Saude
import DocSaudeLoggedListScreen from '../screens/auth/saude/documentos'; //tela de documentos da saude
import DocCadSaudeLoggedListScreen from '../screens/auth/saude/documentos/cadastrar'; //tela de cadastro de documentos da saude
import DocEditSaudeLoggedListScreen from '../screens/auth/saude/documentos/editar'; //tela de edição de documentos da saude
import DocListSaudeLoggedListScreen from '../screens/auth/saude/documentos/listar'; //tela de listagem documentos da saude
import RemumeSaudeLoggedListScreen from '../screens/auth/saude/remume'; //tela de remume da saude
import RemumeCadSaudeLoggedListScreen from '../screens/auth/saude/remume/cadastrar'; //tela de cadastro de remume da saude
import RemumeEditSaudeLoggedListScreen from '../screens/auth/saude/remume/editar'; //tela de edição de remume da saude
import RemumeListSaudeLoggedListScreen from '../screens/auth/saude/remume/listar'; //tela de listagem remume da saude
import ProfSaudeLoggedListScreen from '../screens/auth/saude/profissionais'; //tela de profissionais da saude
import ProfCadSaudeLoggedListScreen from '../screens/auth/saude/profissionais/cadastrar'; //tela de cadastro de profissionais da saude
import ProfEditSaudeLoggedListScreen from '../screens/auth/saude/profissionais/editar'; //tela de edição de profissionais da saude
import ProfListSaudeLoggedListScreen from '../screens/auth/saude/profissionais/listar'; //tela de listagem de profissionais da saude
import ProfVerSaudeLoggedListScreen from '../screens/auth/saude/profissionais/profissional'; //tela do profissional da saude
import ConfSaudeListScreen from '../screens/auth/saude/conferencia/listar'; //tela lista da conferencia da saude
import ConfEditarSaudeScreen from '../screens/auth/saude/conferencia/editar'; //editar Saude
import SMSScreen from '../screens/orgaos/sms'; //tela home saúde
import ConfSaudeScreen from '../screens/saude/conferencia'; //inscrição conferencia da saúde
import ListProfSaudeScreen from '../screens/saude/profissionais'; // listagem pública de profissionais da saúde
import ListAtasAudSaudeScreen from '../screens/saude/atasaudiencia'; // listagem pública de atas de audiencia
import ListAtasConsSaudeScreen from '../screens/saude/atasconselho'; // listagem pública de atas do conselho
import ListParecerSaudeScreen from '../screens/saude/parecer'; // listagem pública parecer do conselho
import ListPlanoAnualSaudeScreen from '../screens/saude/planoanual'; // listagem pública plano anual de saude
import ListPlanoMunSaudeScreen from '../screens/saude/planomunicipal'; // listagem pública plano municipal de saúde
import ListRelAnualSaudeScreen from '../screens/saude/relatorios'; // listagem pública relatórios anuais
import RemumeScreen from '../screens/saude/remume'; //tela principal Remume
import RemumeListScreen from '../screens/saude/remume/listar'; //tela listagem de remédios
import CovidScreen from '../screens/saude/covid'; //tela principal covid
/* fins rotas de saude */

/*rotas de Educacao*/
import EducacaoLoggedListScreen from '../screens/auth/educacao'; //tela lista logada Educacao
import DocEducacaoLoggedListScreen from '../screens/auth/educacao/documentos'; //tela de documentos da Educacao
import DocCadEducacaoLoggedListScreen from '../screens/auth/educacao/documentos/cadastrar'; //tela de cadastro de documentos da Educacao
import DocEditEducacaoLoggedListScreen from '../screens/auth/educacao/documentos/editar'; //tela de edição de documentos da Educacao
import DocListEducacaoLoggedListScreen from '../screens/auth/educacao/documentos/listar'; //tela de listagem documentos da Educacao
import ReceitaEducacaoLoggedListScreen from '../screens/auth/educacao/receita'; //tela de receita da Educacao
import ReceitaCadEducacaoLoggedListScreen from '../screens/auth/educacao/receita/cadastrar'; //tela de cadastro de receita da Educacao
import ReceitaEditEducacaoLoggedListScreen from '../screens/auth/educacao/receita/editar'; //tela de edição de receita da Educacao
import ReceitaListEducacaoLoggedListScreen from '../screens/auth/educacao/receita/listar'; //tela de listagem documentos da Educacao
import DespesaEducacaoLoggedListScreen from '../screens/auth/educacao/despesa'; //tela de Despesa da Educacao
import DespesaCadEducacaoLoggedListScreen from '../screens/auth/educacao/despesa/cadastrar'; //tela de cadastro de Despesa da Educacao
import DespesaEditEducacaoLoggedListScreen from '../screens/auth/educacao/despesa/editar'; //tela de edição de Despesa da Educacao
import DespesaListEducacaoLoggedListScreen from '../screens/auth/educacao/despesa/listar'; //tela de listagem documentos da Educacao
import SMEScreen from '../screens/orgaos/sme'; //tela home educação
import ListAtasConsEducacaoScreen from '../screens/educacao/atasconselho'; // listagem pública de atas do conselho
import ListParecerEducacaoScreen from '../screens/educacao/parecer'; // listagem pública parecer do conselho
import ListPlanoMunEducacaoScreen from '../screens/educacao/planomunicipal'; // listagem pública plano municipal de saúde
import ListRelAnualEducacaoScreen from '../screens/educacao/relatorios'; // listagem pública relatórios anuais
import ListAtasConsAlimentacaoScreen from '../screens/educacao/atasalimentacao'; // listagem pública de atas do conselho de alimentação
import CrecheScreen from '../screens/educacao/creche'; // listagem pública relatórios anuais
import ReceitasEducacaoScreen from '../screens/educacao/receitas'; // listagem pública de arrecadação
import DespesasEducacaoScreen from '../screens/educacao/despesas'; // listagem pública de despesas
/* fins rotas de Educacao */

/* rota cedae */
import CedaeScreen from '../screens/cedae'; //concessão CEDAE
/* fins rotas cedae */

/* rota Emendas RJ */
import EmendaRJScreen from '../screens/emendasrj'; //concessão Emendas RJ
/* fins rotas Emendas RJ */

/* rota ti */
import TIScreen from '../screens/ti'; //tela governaça TI
/* fins ti */

/* rota Atricon */
import AtriconScreen from '../screens/atricon'; //tela atricon
/* fins Atricon */

/* rota Expo macuco */
import ExpoMacucoScreen from '../screens/expomacuco'; //tela Expo Macuco
import ExpoMacuco2025Screen from '../screens/expomacuco/2025'; //tela Expo Macuco 2025
//import ExpoMacuco2025PubliScreen from '../screens/expomacuco/2025/publicacoes'; //tela Expo Macuco 2025 publis
import ExpoMacuco2024Screen from '../screens/expomacuco/2024'; //tela Expo Macuco 2024
//import ExpoMacuco2024PubliScreen from '../screens/expomacuco/2024/publicacoes'; //tela Expo Macuco 2024 publis
import ExpoMacuco2023Screen from '../screens/expomacuco/2023'; //tela Expo Macuco 2023
//import ExpoMacuco2023PubliScreen from '../screens/expomacuco/2023/publicacoes'; //tela Expo Macuco 2023 publis
import ExpoMacucoAntScreen from '../screens/expomacuco/anteriores'; //tela Expo Macuco Anteriores
//import ExpoMacucoAntPubliScreen from '../screens/expomacuco/anteriores/publicacoes'; //tela Expo Macuco Anteriores publis
/* fins Expo macuco */

/* rota Serviços */
import ServicosScreen from '../screens/servicos'; //Serviços online
/* fins Serviços */

/*rotas de Balanco*/
import BalancoScreen from '../screens/balanco'; //tela balanços pública
import BalancoListScreen from '../screens/balanco/listar'; //tela listar balanços pública
import BalancoOrcaScreen from '../screens/balanco/orcamentario'; //tela listar balanços orçamentários
import BalancoFinScreen from '../screens/balanco/financeiro'; //tela listar balanços financeiros
import BalancoPatScreen from '../screens/balanco/patrimonial'; //tela listar balanços patrimoniais
import BalancoLoggedScreen from '../screens/auth/balanco'; //tela logada diário
import EditarBalancoScreen from '../screens/auth/balanco/editar'; //editar Balanco
import CadBalancoScreen from '../screens/auth/balanco/cadastrar'; //cadastrar Balanco
import ListBalancoScreen from '../screens/auth/balanco/listar'; //listar Balancos logado
import TipoBalancoScreen from '../screens/auth/balanco/tipo'; //altera tipo balanço logado
import AnoBalancoScreen from '../screens/auth/balanco/ano'; //altera ano balanço logado
import FundoBalancoScreen from '../screens/auth/balanco/fundo'; //altera fundo balanço logado
/* fins rotas de Balanco */

/*rotas de Transferencias Estado*/
import TransferenciasEstadoScreen from '../screens/transferenciasestado'; //tela Transferencias Estado
import TransferenciasEstadoVoluntariaScreen from '../screens/transferenciasestado/voluntarias'; //tela listar Transferências Voluntárias
import TransferenciasEstadoObrigatoriaScreen from '../screens/transferenciasestado/obrigatorias'; //tela listar Transferências Obrigatória
import TransferenciasEstadoLoggedScreen from '../screens/auth/transferenciasestado'; //tela logada Transferências
import EditarTransferenciasEstadoScreen from '../screens/auth/transferenciasestado/editar'; //editar transferencias Estado
import CadTransferenciasEstadoScreen from '../screens/auth/transferenciasestado/cadastrar'; //cadastrar transferencias Estado
import ListTransferenciasEstadoScreen from '../screens/auth/transferenciasestado/listar'; //listar transferencias Estados logado
/* fins rotas de Transferencias Estado */



const Rotas = () => {
    return (
        <BrowserRouter basename='/transparencia'>
            <Routes>
                <Route exact path="/" element={<HomeScreen />} />
                <Route exact path="/login" element={<LoginScreen />} />

                {/*rotas Perguntas*/}
                <Route exact path="/perguntas" element={<PerguntasScreen />} />
                {/*fim rotas Perguntas*/}

                {/*rotas LGPD*/}
                <Route exact path="/lgpd" element={<LGPDScreen />} />
                <Route exact path="/lgpd/formulario" element={<LGPDFormScreen />} />
                {/*fim rotas LGPD*/}

                {/*rotas Social*/}
                <Route exact path="/social" element={<SocialScreen />} />
                <Route exact path="/social/auxiliomacuco" element={<AuxilioMacucoScreen />} />
                {/*fim rotas Social*/}

                {/*rotas Ti*/}
                <Route exact path="/ti" element={<TIScreen />} />
                {/*fim rotas Ti*/}

                {/*rotas Serviços*/}
                <Route exact path="/servicos" element={<ServicosScreen />} />
                {/*fim rotas Serviços*/}

                {/*rotas Expo Macuco*/}
                <Route exact path="/expomacuco" element={<ExpoMacucoScreen />} />
                <Route exact path="/expomacuco/2025" element={<ExpoMacuco2025Screen />} />
                {/*<Route exact path="/expomacuco/2025/publicacoes" element={<ExpoMacuco2025PubliScreen />} />*/}
                <Route exact path="/expomacuco/2024" element={<ExpoMacuco2024Screen />} />
                {/*<Route exact path="/expomacuco/2024/publicacoes" element={<ExpoMacuco2024PubliScreen />} />*/}
                <Route exact path="/expomacuco/2023" element={<ExpoMacuco2023Screen />} />
                {/*<Route exact path="/expomacuco/2023/publicacoes" element={<ExpoMacuco2023PubliScreen />} />*/}
                <Route exact path="/expomacuco/anteriores" element={<ExpoMacucoAntScreen />} />
                {/*<Route exact path="/expomacuco/anteriores/publicacoes" element={<ExpoMacucoAntPubliScreen />} />*/}
                {/*fim rotas Expo Macuco*/}

                {/*rotas Atricon*/}
                <Route exact path="/atricon" element={<AtriconScreen />} />
                {/*fim rotas Atricon*/}

                {/*rotas Emendas RJ*/}
                <Route exact path="/emendasrj" element={<EmendaRJScreen />} />
                {/*fim rotas Emendas RJ*/}

                {/*rotas Mapa do Site*/}
                <Route exact path="/mapa" element={<MapaScreen />} />
                {/*fim rotas Mapa do Site*/}

                {/*rotas Institucional*/}
                <Route exact path="/orgaos" element={<OrgaosScreen />} />
                <Route exact path="/orgaos/sme" element={<SMEScreen />} />
                <Route exact path="/orgaos/carta" element={<CartaScreen />} />
                <Route exact path="/orgaos/secretarias" element={<SecretariaScreen />} />
                <Route exact path="/orgaos/locais/saude" element={<ListLocsSaudeScreen />} />
                <Route exact path="/orgaos/locais/educacao" element={<ListLocsEducScreen />} />
                <Route exact path="/orgaos/locais/social" element={<ListLocsSocialScreen />} />
                <Route exact path="/orgaos/locais/esporte" element={<ListLocsEsporteScreen />} />
                <Route exact path="/orgaos/locais" element={<ListLocsTodasScreen />} />
                {/*fim rotas institucional*/}

                {/*rotas RH*/}
                <Route exact path="/folha" element={<FolhaScreen />} />
                <Route exact path="/folha/concursos" element={<ConcursoScreen />} />
                <Route exact path="/folha/concursos/2001" element={<Concurso2001Screen />} />
                <Route exact path="/folha/concursos/2010" element={<Concurso2010Screen />} />
                <Route exact path="/folha/concursos/2012" element={<Concurso2012Screen />} />
                <Route exact path="/folha/estagiarios" element={<EstagiariosScreen />} />
                <Route exact path="/folha/terceirizados" element={<TerceirizadosScreen />} />
                {/*fim rotas RH*/}

                {/*rotas diárias de viagem*/}
                <Route exact path="/diarias" element={<DiariasScreen />} />
                <Route exact path="/diarias/tabela" element={<TabelaDiariasScreen />} />
                {/*fim rotas diárias de viagem*/}

                {/*rotas Renuncias de Receita*/}
                <Route exact path="/renuncias" element={<RenunciasScreen />} />
                <Route exact path="/projetocultural" element={<ProjetoculturalScreen />} />
                <Route exact path="/renunciareceita" element={<RenunciaReceitaScreen />} />
                {/*fim rotas Renuncias de Receita*/}

                {/*rotas CEDAE*/}
                <Route exact path="/concessaocedae" element={<CedaeScreen />} />
                {/*fim rotas CEDAE*/}

                {/*rotas Contas*/}
                <Route exact path="/contas" element={<ContasScreen />} />
                <Route exact path="/contas/prestacaocontas" element={<PrestContasScreen />} />
                <Route exact path="/contas/camara" element={<CamaraPrestScreen />} />
                <Route exact path="/contas/renuncias" element={<RenunciaDocScreen />} />
                <Route exact path="/contas/audiencias" element={<AudPubScreen />} />
                <Route exact path="/contas/audiencias/metasfiscais" element={<MetasFiscaisScreen />} />
                {/*fim rotas Contas*/}

                {/*rotas Diários*/}
                <Route exact path="/diario" element={<DiarioScreen />} />
                <Route exact path="/diario/expomacuco/2025" element={<DiarioExpo2025Screen />} />
                <Route exact path="/diario/expomacuco/2024" element={<DiarioExpo2024Screen />} />
                <Route exact path="/diario/expomacuco/2023" element={<DiarioExpo2023Screen />} />
                <Route exact path="/diario/expomacuco/anteriores" element={<DiarioExpoAntScreen />} />
                {/*fim rotas Diários*/}

                {/*rotas Veículos*/}
                <Route exact path="/veiculos" element={<VeiculosScreen />} />
                {/*fim rotas Veículos*/}

                {/*rotas Atos*/}
                <Route exact path="/atos" element={<AtosScreen />} />
                {/*fim rotas Atos*/}

                {/*rotas Divida*/}
                <Route exact path="/dividaativa" element={<DividaScreen />} />
                {/*fim rotas Divida*/}

                {/*rotas Partidos*/}
                <Route exact path="/partidospoliticos" element={<PartidoScreen />} />
                {/*fim rotas Partidos*/}

                {/*rotas Obras*/}
                <Route exact path="/obras" element={<ObrasScreen />} />
                <Route exact path="/obras/todas" element={<TodasObrasScreen />} />
                <Route exact path="/obras/paralizadas" element={<ObrasParalizadasScreen />} />
                {/*fim rotas Obras*/}

                {/*rotas Balanços*/}
                <Route exact path="/balanco" element={<BalancoScreen />} />
                <Route exact path="/balanco/listar" element={<BalancoListScreen />} />
                <Route exact path="/balanco/orcamentario" element={<BalancoOrcaScreen />} />
                <Route exact path="/balanco/financeiro" element={<BalancoFinScreen />} />
                <Route exact path="/balanco/patrimonial" element={<BalancoPatScreen />} />
                {/*fim rotas Balanços*/}

                {/*rotas Transferências Estaduais*/}
                <Route exact path="/transferenciasestado" element={<TransferenciasEstadoScreen />} />
                <Route exact path="/transferenciasestado/voluntarias" element={<TransferenciasEstadoVoluntariaScreen />} />
                <Route exact path="/transferenciasestado/obrigatorias" element={<TransferenciasEstadoObrigatoriaScreen />} />
                {/*fim rotas Transferências Estaduais*/}

                {/*rotas LRF*/}
                <Route exact path="/lrf" element={<LrfScreen />} />
                <Route exact path="/lrf/listar" element={<LrfListScreen />} />
                <Route exact path="/lrf/rreo" element={<RreoScreen />} />
                <Route exact path="/lrf/rgf" element={<RgfScreen />} />
                <Route exact path="/lrf/dcrgf" element={<DcrgfScreen />} />
                {/*fim rotas LRF*/}

                {/*rotas Ouvidoria*/}
                <Route exact path="/ouvidoria" element={<HomeOuvidoriaScreen />} />
                <Route exact path="/ouvidoria/cadastrar" element={<CadOuvidoriaScreen />} />
                <Route exact path="/ouvidoria/estatisticas" element={<EstOuvidoriaScreen />} />
                <Route exact path="/ouvidoria/listar" element={<ListOuvidoriaScreen />} />
                <Route exact path="/ouvidoria/comopedir" element={<ComoPedirOuvidoriaScreen />} />
                <Route exact path="/ouvidoria/comoacompanhar" element={<ComoAcompOuvidoriaScreen />} />
                <Route exact path="/ouvidoria/recurso" element={<RecursoOuvidoriaScreen />} />
                <Route exact path="/ouvidoria/leis" element={<LeisOuvidoriaScreen />} />
                <Route exact path="/ouvidoria/informacoes" element={<InfoOuvidoriaScreen />} />
                <Route exact path="/ouvidoria/manuais" element={<ManuaisOuvidoriaScreen />} />
                <Route exact path="/ouvidoria/publicas" element={<PublicasOuvidoriaScreen />} />
                <Route exact path="/ouvidoria/sigilo" element={<SigiloOuvidoriaScreen />} />
                <Route exact path="/ouvidoria/desclassificadas" element={<DesclassificadasOuvidoriaScreen />} />
                <Route exact path="/ouvidoria/responder/:id" element={<RespOuvidoriaScreen />} />
                <Route exact path="/pesquisa" element={<PesquisaScreen />} />
                <Route exact path="/pesquisa/resultados" element={<ResultadoPesquisaScreen />} />
                {/*fim rotas Ouvidoria*/}

                {/*rotas Saude*/}
                <Route exact path="/saude" element={<SMSScreen />} />
                <Route exact path="/saude/conferenciasaude" element={<ConfSaudeScreen />} />
                <Route exact path="/saude/profissionais" element={<ListProfSaudeScreen />} />
                <Route exact path="/saude/atasaudiencia" element={<ListAtasAudSaudeScreen />} />
                <Route exact path="/saude/atasconselho" element={<ListAtasConsSaudeScreen />} />
                <Route exact path="/saude/parecer" element={<ListParecerSaudeScreen />} />
                <Route exact path="/saude/planoanual" element={<ListPlanoAnualSaudeScreen />} />
                <Route exact path="/saude/planomunicipal" element={<ListPlanoMunSaudeScreen />} />
                <Route exact path="/saude/relatorioanual" element={<ListRelAnualSaudeScreen />} />
                <Route exact path="/saude/remume" element={<RemumeScreen />} />
                <Route exact path="/saude/remume/listar" element={<RemumeListScreen />} />
                <Route exact path="/saude/covid" element={<CovidScreen />} />
                {/*fim rotas saude*/}

                {/*rotas Educacao*/}
                <Route exact path="/educacao" element={<SMEScreen />} />
                <Route exact path="/educacao/atasconselho" element={<ListAtasConsEducacaoScreen />} />
                <Route exact path="/educacao/atasalimentacao" element={<ListAtasConsAlimentacaoScreen />} />
                <Route exact path="/educacao/parecer" element={<ListParecerEducacaoScreen />} />
                <Route exact path="/educacao/planomunicipal" element={<ListPlanoMunEducacaoScreen />} />
                <Route exact path="/educacao/relatorioanual" element={<ListRelAnualEducacaoScreen />} />
                <Route exact path="/educacao/creche" element={<CrecheScreen />} />
                <Route exact path="/educacao/receita" element={<ReceitasEducacaoScreen />} />
                <Route exact path="/educacao/despesa" element={<DespesasEducacaoScreen />} />
                {/*fim rotas educacao*/}

                {/*rotas de licitações pública*/}
                <Route exact path="/licitacao" element={<LicsScreen />} />
                <Route exact path="/licitacao/todas" element={<LicsTodasScreen />} />
                <Route exact path="/licitacao/aviso" element={<AvisosLicScreen />} />
                <Route exact path="/licitacao/andamento" element={<AndamentoLicScreen />} />
                <Route exact path="/licitacao/encerradas" element={<EncerradasLicScreen />} />
                <Route exact path="/licitacao/covid" element={<CovidLicScreen />} />
                <Route exact path="/licitacao/dispensa-covid" element={<DispensaCovidScreen />} />
                <Route exact path="/licitacao/expomacuco/2025" element={<Expo25LicitacaoScreen />} />
                <Route exact path="/licitacao/expomacuco/2024" element={<Expo24LicitacaoScreen />} />
                <Route exact path="/licitacao/expomacuco/2023" element={<Expo23LicitacaoScreen />} />
                <Route exact path="/licitacao/expomacuco/anteriores" element={<ExpoAntLicitacaoScreen />} />
                {/*fim rotas licitações pública*/}

                {/*rotas de contratos pública*/}
                <Route exact path="/contratos" element={<ContratosScreen />} />
                <Route exact path="/contratos/listar" element={<ListContratosScreen />} />
                <Route exact path="/contratos/covid" element={<CovidContratosScreen />} />
                <Route exact path="/contratos/expomacuco/2025" element={<Expo25ContratosScreen />} />
                <Route exact path="/contratos/expomacuco/2024" element={<Expo24ContratosScreen />} />
                <Route exact path="/contratos/expomacuco/2023" element={<Expo23ContratosScreen />} />
                <Route exact path="/contratos/expomacuco/anteriores" element={<ExpoAntContratosScreen />} />
                <Route exact path="/contratos/fiscais" element={<FiscaisContratosScreen />} />
                <Route exact path="/contratos/sancionados" element={<ContratadosContratosScreen />} />
                <Route exact path="/contratos/licitantes" element={<LicitantesContratosScreen />} />
                <Route exact path="/contratos/chamamentos" element={<ChamamentosContratosScreen />} />
                {/* fim rotas de contratos pública*/}


                {/*rotas adm*/}
                <Route exact path="/restrito" element={<PrivateRoute />}>
                    <Route exact path="/restrito" element={<AdmLoggedScreen />} />
                    {/*rotas diário*/}
                    <Route exact path="/restrito/diario" element={<DiarioLoggedScreen />} />
                    <Route exact path="/restrito/diario/cadastrar" element={<CadDiarioScreen />} />
                    <Route exact path="/restrito/diario/listar" element={<ListDiarioScreen />} />
                    <Route exact path="/restrito/diario/editar/:id" element={<EditarDiarioScreen />} />
                    <Route exact path="/restrito/diario/arquivo/:id" element={<ArquivoDiarioScreen />} />
                    {/*fim rotas diário*/}

                    {/*rotas diário*/}
                    <Route exact path="/restrito/veiculos" element={<VeiculoLoggedScreen />} />
                    <Route exact path="/restrito/veiculos/cadastrar" element={<CadVeiculosScreen />} />
                    <Route exact path="/restrito/veiculos/listar" element={<ListVeiculosScreen />} />
                    <Route exact path="/restrito/veiculos/editar/:id" element={<EditarVeiculosScreen />} />
                    {/*fim rotas diário*/}

                    {/*rotas atos do governo*/}
                    <Route exact path="/restrito/atos" element={<AtosLoggedScreen />} />
                    <Route exact path="/restrito/atos/cadastrar" element={<CadAtosScreen />} />
                    <Route exact path="/restrito/atos/listar" element={<ListAtosScreen />} />
                    <Route exact path="/restrito/atos/editar/:id" element={<EditarAtosScreen />} />
                    <Route exact path="/restrito/atos/arquivo/:id" element={<ArquivoAtosScreen />} />
                    {/*fim rotas atos do governo*/}

                    {/*rotas divida ativa*/}
                    <Route exact path="/restrito/divida" element={<DividaLoggedScreen />} />
                    <Route exact path="/restrito/divida/cadastrar" element={<CadDividaScreen />} />
                    <Route exact path="/restrito/divida/listar" element={<ListDividaScreen />} />
                    <Route exact path="/restrito/divida/editar/:id" element={<EditarDividaScreen />} />
                    {/*fim rotas divida ativa*/}

                    {/*rotas secretaria*/}
                    <Route exact path="/restrito/institucional/secretaria" element={<SecretariaLoggedScreen />} />
                    <Route exact path="/restrito/institucional" element={<InstitucionalLoggedScreen />} />
                    <Route exact path="/restrito/institucional/secretaria/cadastrar" element={<CadSecretariaScreen />} />
                    <Route exact path="/restrito/institucional/secretaria/listar" element={<ListSecretariaScreen />} />
                    <Route exact path="/restrito/institucional/secretaria/editar/:id" element={<EditarSecretariaScreen />} />
                    <Route exact path="/restrito/institucional/cartaservico" element={<CartaServicoLoggedScreen />} />
                    <Route exact path="/restrito/institucional/cartaservico/cadastrar" element={<CadCartaServicoScreen />} />
                    <Route exact path="/restrito/institucional/cartaservico/listar" element={<ListCartaServicoScreen />} />
                    <Route exact path="/restrito/institucional/cartaservico/editar/:id" element={<EditarCartaServicoScreen />} />
                    <Route exact path="/restrito/institucional/cartaservico/carta/:id" element={<VisualizarCartaServicoScreen />} />
                    <Route exact path="/restrito/institucional/locais" element={<LocLoggedScreen />} />
                    <Route exact path="/restrito/institucional/locais/cadastrar" element={<LocCadLoggedListScreen />} />
                    <Route exact path="/restrito/institucional/locais/listar" element={<LocListLoggedListScreen />} />
                    <Route exact path="/restrito/institucional/locais/editar/:id" element={<LocEditLoggedListScreen />} />
                    {/*fim rotas secretaria*/}

                    {/*rotas renuncias de receitas e projetos culturais*/}
                    <Route exact path="/restrito/renuncias/projetocultural" element={<ProjetoCulturalLoggedScreen />} />
                    <Route exact path="/restrito/renuncias/projetocultural/cadastrar" element={<CadProjetoCulturalScreen />} />
                    <Route exact path="/restrito/renuncias/projetocultural/listar" element={<ListProjetoCulturalScreen />} />
                    <Route exact path="/restrito/renuncias/projetocultural/editar/:id" element={<EditarProjetoCulturalScreen />} />
                    <Route exact path="/restrito/renuncias/renunciareceita" element={<RenunciaReceitaLoggedScreen />} />
                    <Route exact path="/restrito/renuncias" element={<RenunciasLoggedScreen />} />
                    <Route exact path="/restrito/renuncias/renunciareceita/cadastrar" element={<CadRenunciaReceitaScreen />} />
                    <Route exact path="/restrito/renuncias/renunciareceita/listar" element={<ListRenunciaReceitaScreen />} />
                    <Route exact path="/restrito/renuncias/renunciareceita/editar/:id" element={<EditarRenunciaReceitaScreen />} />
                    {/*fim rotas renuncias de receitas e projetos culturais*/}

                    {/*rotas obras*/}
                    <Route exact path="/restrito/obras" element={<ObrasLoggedScreen />} />
                    <Route exact path="/restrito/obras/cadastrar" element={<CadObraScreen />} />
                    <Route exact path="/restrito/obras/listar" element={<ListObraScreen />} />
                    <Route exact path="/restrito/obras/editar/:id" element={<EditarObraScreen />} />
                    {/*fim rotas obras*/}

                    {/*rotas Diárias*/}
                    <Route exact path="/restrito/diarias" element={<DiariasLoggedScreen />} />
                    <Route exact path="/restrito/diarias/cadastrar" element={<CadDiariascreen />} />
                    <Route exact path="/restrito/diarias/listar" element={<ListDiariascreen />} />
                    <Route exact path="/restrito/diarias/editar/:id" element={<EditarDiariascreen />} />
                    {/*fim rotas Diárias*/}

                    {/*rotas prestação de contas*/}
                    <Route exact path="/restrito/contas" element={<ContasLoggedScreen />} />
                    <Route exact path="/restrito/contas/cadastrar" element={<CadContasScreen />} />
                    <Route exact path="/restrito/contas/listar" element={<ListContasScreen />} />
                    <Route exact path="/restrito/contas/editar/:id" element={<EditarContasScreen />} />
                    {/*fim rotas prestação de contas*/}

                    {/*rotas RH*/}
                    <Route exact path="/restrito/rh" element={<RHLoggedScreen />} />
                    <Route exact path="/restrito/rh/concurso" element={<ConcursoLoggedScreen />} />
                    <Route exact path="/restrito/rh/estagiario" element={<EstagiarioLoggedScreen />} />
                    <Route exact path="/restrito/rh/terceirizado" element={<TerceirizadoLoggedScreen />} />
                    <Route exact path="/restrito/rh/concurso/cadastrar" element={<CadConcursoScreen />} />
                    <Route exact path="/restrito/rh/concurso/listar" element={<ListConcursosScreen />} />
                    <Route exact path="/restrito/rh/concurso/editar/:id" element={<EditarConcursoScreen />} />
                    <Route exact path="/restrito/rh/estagiario/cadastrar" element={<CadEstagiarioScreen />} />
                    <Route exact path="/restrito/rh/estagiario/listar" element={<ListEstagiariosScreen />} />
                    <Route exact path="/restrito/rh/estagiario/editar/:id" element={<EditarEstagiarioScreen />} />
                    <Route exact path="/restrito/rh/terceirizado/cadastrar" element={<CadTerceirizadoScreen />} />
                    <Route exact path="/restrito/rh/terceirizado/listar" element={<ListTerceirizadosScreen />} />
                    <Route exact path="/restrito/rh/terceirizado/editar/:id" element={<EditarTerceirizadoScreen />} />
                    {/*fim rotas RH*/}

                    {/*rotas partidos políticos*/}
                    <Route exact path="/restrito/partido" element={<PartidoLoggedScreen />} />
                    <Route exact path="/restrito/partido/cadastrar" element={<CadPartidoScreen />} />
                    <Route exact path="/restrito/partido/listar" element={<ListPartidoScreen />} />
                    <Route exact path="/restrito/partido/editar/:id" element={<EditarPartidoScreen />} />
                    <Route exact path="/restrito/partido/arquivo/:id" element={<ArquivoPartidoScreen />} />
                    {/*fim rotas partidos políticos*/}

                    {/*rotas lrf*/}
                    <Route exact path="/restrito/lrf" element={<LrfLoggedScreen />} />
                    <Route exact path="/restrito/lrf/cadastrar" element={<CadLrfScreen />} />
                    <Route exact path="/restrito/lrf/listar" element={<ListLrfScreen />} />
                    <Route exact path="/restrito/lrf/editar/:id" element={<EditarLrfScreen />} />
                    {/*fim rotas lrf*/}

                    {/*rotas ouvidoria*/}
                    <Route exact path="/restrito/ouvidoria/adm" element={<AdmLoggedListScreen />} />
                    <Route exact path="/restrito/ouvidoria/editar/:id" element={<EditarOuvidoriaScreen />} />
                    <Route exact path="/restrito/ouvidoria/esic" element={<EsicLoggedListScreen />} />
                    <Route exact path="/restrito/ouvidoria/pesquisa" element={<PesquisaLoggedScreen />} />
                    <Route exact path="/restrito/ouvidoria" element={<OuvidoriaLoggedScreen />} />
                    {/*fim rotas ouvidoria*/}

                    {/*rotas saude*/}
                    <Route exact path="/restrito/saude" element={<SaudeLoggedListScreen />} />
                    <Route exact path="/restrito/saude/conferencia/editar/:id" element={<ConfEditarSaudeScreen />} />
                    <Route exact path="/restrito/saude/conferencia/listar" element={<ConfSaudeListScreen />} />
                    <Route exact path="/restrito/saude/documentos" element={<DocSaudeLoggedListScreen />} />
                    <Route exact path="/restrito/saude/documentos/listar" element={<DocListSaudeLoggedListScreen />} />
                    <Route exact path="/restrito/saude/documentos/editar/:id" element={<DocEditSaudeLoggedListScreen />} />
                    <Route exact path="/restrito/saude/documentos/cadastrar" element={<DocCadSaudeLoggedListScreen />} />
                    <Route exact path="/restrito/saude/remume" element={<RemumeSaudeLoggedListScreen />} />
                    <Route exact path="/restrito/saude/remume/listar" element={<RemumeListSaudeLoggedListScreen />} />
                    <Route exact path="/restrito/saude/remume/editar/:id" element={<RemumeEditSaudeLoggedListScreen />} />
                    <Route exact path="/restrito/saude/remume/cadastrar" element={<RemumeCadSaudeLoggedListScreen />} />
                    <Route exact path="/restrito/saude/profissionais" element={<ProfSaudeLoggedListScreen />} />
                    <Route exact path="/restrito/saude/profissionais/listar" element={<ProfListSaudeLoggedListScreen />} />
                    <Route exact path="/restrito/saude/profissionais/editar/:id" element={<ProfEditSaudeLoggedListScreen />} />
                    <Route exact path="/restrito/saude/profissionais/cadastrar" element={<ProfCadSaudeLoggedListScreen />} />
                    <Route exact path="/restrito/saude/profissionais/profissional/:id" element={<ProfVerSaudeLoggedListScreen />} />
                    {/*fim rotas saude*/}

                    {/*rotas Educacao*/}
                    <Route exact path="/restrito/educacao" element={<EducacaoLoggedListScreen />} />
                    <Route exact path="/restrito/educacao/documentos" element={<DocEducacaoLoggedListScreen />} />
                    <Route exact path="/restrito/educacao/documentos/listar" element={<DocListEducacaoLoggedListScreen />} />
                    <Route exact path="/restrito/educacao/documentos/editar/:id" element={<DocEditEducacaoLoggedListScreen />} />
                    <Route exact path="/restrito/educacao/documentos/cadastrar" element={<DocCadEducacaoLoggedListScreen />} />
                    <Route exact path="/restrito/educacao/receitas" element={<ReceitaEducacaoLoggedListScreen />} />
                    <Route exact path="/restrito/educacao/receitas/listar" element={<ReceitaListEducacaoLoggedListScreen />} />
                    <Route exact path="/restrito/educacao/receitas/editar/:id" element={<ReceitaEditEducacaoLoggedListScreen />} />
                    <Route exact path="/restrito/educacao/receitas/cadastrar" element={<ReceitaCadEducacaoLoggedListScreen />} />
                    <Route exact path="/restrito/educacao/despesas" element={<DespesaEducacaoLoggedListScreen />} />
                    <Route exact path="/restrito/educacao/despesas/listar" element={<DespesaListEducacaoLoggedListScreen />} />
                    <Route exact path="/restrito/educacao/despesas/editar/:id" element={<DespesaEditEducacaoLoggedListScreen />} />
                    <Route exact path="/restrito/educacao/despesas/cadastrar" element={<DespesaCadEducacaoLoggedListScreen />} />
                    {/*fim rotas Educacao*/}

                    {/*rotas de usuários*/}
                    <Route exact path="/restrito/usuarios" element={<UserLoggedScreen />} />
                    <Route exact path="/restrito/usuarios/cadastrar" element={<CadUserScreen />} />
                    <Route exact path="/restrito/usuarios/listar" element={<ListUserScreen />} />
                    <Route exact path="/restrito/usuarios/editar/:id" element={<EditarUserScreen />} />
                    <Route exact path="/restrito/usuarios/senha/:id" element={<SenhaScreen />} />
                    {/*fim rotas de usuários*/}

                    {/*rotas balanco*/}
                    <Route exact path="/restrito/controle" element={<ControleLoggedScreen />} />
                    <Route exact path="/restrito/balanco" element={<BalancoLoggedScreen />} />
                    <Route exact path="/restrito/balanco/cadastrar" element={<CadBalancoScreen />} />
                    <Route exact path="/restrito/balanco/listar" element={<ListBalancoScreen />} />
                    <Route exact path="/restrito/balanco/editar/:id" element={<EditarBalancoScreen />} />
                    <Route exact path="/restrito/balanco/tipo/:id" element={<TipoBalancoScreen />} />
                    <Route exact path="/restrito/balanco/ano/:id" element={<AnoBalancoScreen />} />
                    <Route exact path="/restrito/balanco/fundo/:id" element={<FundoBalancoScreen />} />
                    {/*fim rotas balanco*/}

                    {/*rotas Transferências Estaduais*/}
                    <Route exact path="/restrito/transferenciasestado" element={<TransferenciasEstadoLoggedScreen />} />
                    <Route exact path="/restrito/transferenciasestado/cadastrar" element={<CadTransferenciasEstadoScreen />} />
                    <Route exact path="/restrito/transferenciasestado/listar" element={<ListTransferenciasEstadoScreen />} />
                    <Route exact path="/restrito/transferenciasestado/editar/:id" element={<EditarTransferenciasEstadoScreen />} />
                    {/*fim rotas Transferências Estaduais*/}

                    {/*rotas licitações*/}
                    <Route exact path="/restrito/licitacao" element={<HomeLoggedLicScreen />} />
                    <Route exact path="/restrito/licitacao/licitacao/:id" element={<LicScreen />} />
                    <Route exact path="/restrito/licitacao/cadastrar" element={<CadLicScreen />} />
                    <Route exact path="/restrito/licitacao/aviso" element={<CadAvisoScreen />} />
                    <Route exact path="/restrito/licitacao/listar/andamento" element={<ListLicAtivaScreen />} />
                    <Route exact path="/restrito/licitacao/listar/encerradas" element={<ListLicEncScreen />} />
                    <Route exact path="/restrito/licitacao/listar/avisos" element={<ListAvisosScreen />} />
                    <Route exact path="/restrito/licitacao/listar/todas" element={<ListTodasScreen />} />
                    <Route exact path="/restrito/licitacao/editar/:id" element={<EditarLicScreen />} />
                    <Route exact path="/restrito/licitacao/objeto/:id" element={<ObjetiLicScreen />} />
                    <Route exact path="/restrito/licitacao/valor/:id" element={<ValorLicScreen />} />
                    <Route exact path="/restrito/licitacao/situacao/:id" element={<SituacaoLicScreen />} />
                    <Route exact path="/restrito/licitacao/anexos/:id" element={<AnexosLicScreen />} />
                    {/*fim rotas licitações*/}

                    {/*rotas contratos*/}
                    <Route exact path="/restrito/contratos" element={<HomeLoggedContratoScreen />} />
                    <Route exact path="/restrito/contratos/contrato/:id" element={<ContratoScreen />} />
                    <Route exact path="/restrito/contratos/cadastrar" element={<CadContratoScreen />} />
                    <Route exact path="/restrito/contratos/listar" element={<ListContratoScreen />} />
                    <Route exact path="/restrito/contratos/fiscais" element={<FiscContratoScreen />} />
                    <Route exact path="/restrito/contratos/fiscais/cadastrar" element={<CadFiscContratoScreen />} />
                    <Route exact path="/restrito/contratos/fiscais/listar" element={<ListFiscContratoScreen />} />
                    <Route exact path="/restrito/contratos/fiscais/editar/:id" element={<EditarFiscContratoScreen />} />
                    <Route exact path="/restrito/contratos/chamamento/" element={<ChamamentoSaudeScreen />} />
                    <Route exact path="/restrito/contratos/editar/:id" element={<EditarContratoScreen />} />
                    <Route exact path="/restrito/contratos/situacao/:id" element={<SituacaoContratoScreen />} />
                    <Route exact path="/restrito/contratos/aditivo/:id" element={<AditivoContratoScreen />} />
                    {/*fim rotas contratos*/}

                </Route>
                {/*fim rotas adm*/}

                {/*rotas de leis*/}
                <Route exact path="/leis" element={<LeisScreen />} />
                <Route exact path="/leis/orcamento" element={<OrcamentoLeiScreen />} />
                <Route exact path="/leis/decretos" element={<DecretosScreen />} />
                <Route exact path="/leis/municipais" element={<MunicipaisScreen />} />
                <Route exact path="/leis/transparencia" element={<TranspScreen />} />
                <Route exact path="/leis/loa" element={<LoaScreen />} />
                <Route exact path="/leis/ldo" element={<LdoScreen />} />
                <Route exact path="/leis/ppa" element={<PpaScreen />} />
                <Route exact path="/leis/covid" element={<CovidLeisScreen />} />
                <Route exact path="/restrito/leis" element={<PrivateLeiRoute />}>
                    <Route exact path="/restrito/leis" element={<HomeLoggedLeiScreen />} />
                    <Route exact path="/restrito/leis/cadastrar" element={<CadLeiScreen />} />
                    <Route exact path="/restrito/leis/indiceleis" element={<IndLeiScreen />} />
                    <Route exact path="/restrito/leis/listar" element={<ListLeiScreen />} />
                    <Route exact path="/restrito/leis/indicedecretos" element={<IndDecScreen />} />
                    <Route exact path="/restrito/leis/editar/:id" element={<EditarLeiScreen />} />
                    <Route exact path="/restrito/leis/data/:id" element={<DataLeiScreen />} />
                    <Route exact path="/restrito/leis/jornal/:id" element={<JornalLeiScreen />} />
                    <Route exact path="/restrito/leis/ementa/:id" element={<EmentaLeiScreen />} />
                    <Route exact path="/restrito/leis/arquivo/:id" element={<ArquivoLeiScreen />} />
                </Route>
                {/* fim rotas de leis*/}
            </Routes>
        </BrowserRouter>
    )
}

export default Rotas;